// 状态
export const STATUS = {
    1: '启用',
    0: '停用',
    2: '未启用',
    start: {
        key: 1,
        value: '启用'
    },
    stop: {
        key: 0,
        value: '停用'
    },
    unStart: {
        key: 2,
        value: '未启用'
    }
}
export const STATUS_LIST = [
    {
        key: 1,
        name: '启用'
    },
    {
        key: 0,
        name: '停用'
    }, {
        key: 2,
        name: '未启用'
    }
]
export const WAREHOUSE_TYPE_VALUE_ENUM = {
  VMI: 6
}

// 仓库类型
export const WAREHOUSE_TYPE = {
    1: '原材料',
    2: '仓线边仓',
    3: '零部件仓',
    4: '成品仓',
    5: '不良品仓',
    [WAREHOUSE_TYPE_VALUE_ENUM.VMI]: 'VMI仓',
    material: {
      key: 1,
      value: '原材料'
    },
    side: {
      key: 2,
      value: '仓线边仓'
    },
    parts: {
      key: 3,
      value: '零部件仓'
    },
    product: {
      key: 4,
      value: '成品仓'
    },
    rejects: {
      key: 5,
      value: '不良品仓'
    }
}
export const WAREHOUSE_TYPE_LIST = [
    {
        key: 1,
        value: '原材料'
    },
    {
        key: 2,
        value: '仓线边仓'
    },
    {
        key: 3,
        value: '零部件仓'
    },
    {
        key: 4,
        value: '成品仓'
    },
    {
        key: 5,
        value: '不良品仓'
    },
    {
      key: WAREHOUSE_TYPE_VALUE_ENUM.VMI,
      value: 'VMI仓'
    }
]
